import React from "react";
import { fonts, scoreColor } from "../theme";

export default function BreakdownGrid({ criteria, score, theme }) {
  return (
    <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))", gap: 14 }}>
      {criteria.map(c => {
        const val = Number(score?.[c.avgKey]) || 0;
        const pct = (val / 10) * 100;
        const color = scoreColor(300 + val * 60, theme);
        return (
          <div key={c.avgKey} style={{ background: theme.surface, border: `1px solid ${theme.line}`, borderRadius: 10, padding: 14 }}>
            <div style={{ display: "flex", alignItems: "center", gap: 6, fontSize: 12.5, color: theme.text, marginBottom: 8 }}>
              <c.icon size={13} color={theme.textMute} /> {c.label}
            </div>
            <div style={{ display: "flex", alignItems: "baseline", gap: 6, marginBottom: 6 }}>
              <span style={{ fontFamily: fonts.mono, fontSize: 18, color }}>{val.toFixed(1)}</span>
              <span style={{ fontSize: 11, color: theme.textMute }}>/ 10</span>
            </div>
            <div style={{ height: 4, background: theme.line, borderRadius: 2, overflow: "hidden" }}>
              <div style={{ height: "100%", width: `${pct}%`, background: color }} />
            </div>
          </div>
        );
      })}
    </div>
  );
}
